import { useTranslation } from 'react-i18next';
import { Upload } from 'lucide-react';
import { ImportWizard } from '@/features/imports/ImportWizard';

export function ImportPage() {
  const { t } = useTranslation(['import']);
  return (
    <div className="animate-fade-in mx-auto max-w-3xl space-y-6 py-6">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-forest-100 text-forest-700 dark:bg-forest-900/40 dark:text-forest-300">
          <Upload className="h-5 w-5" />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100">{t('title')}</h1>
          <p className="text-sm text-slate-500 dark:text-slate-400">{t('subtitle')}</p>
        </div>
      </div>
      <ImportWizard />
    </div>
  );
}
